import { Injectable } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ExternalService {

  constructor(
    private _utilsService: UtilsService
  ) { }

  /**
   * Function - getUserProfile(brandId, customerId, authKey, loggedInManagerId, cb) 
   * Added by - Terkam Patel - 19th June 2017
   * @description Method to get the auth key by brandId, customerId, authKey and loggedInManagerId from tokenization server
   *
   * @param      {string}  brandId                Contains id of the brand
   * @param      {string}  customerId             Contains id of the customer
   * @param      {string}  auth_key               Auth key to get the user profile details
   * @param      {string}  loggedInManagerId      Id of the logged in manager who want to get the user profile details
   * @param      {string}  apiUrl                 Url of the token server exposed api to get the user profile details
   */
  getUserProfile(brandId, customerId, authKey, loggedInManagerId, tsApiUrl, feedId, requestType) {
    //create the body params needs to be send as a body parameters to get the user info from tokenization server
    var bodyParams: any = {
      brand_id: brandId,
      user_token: customerId,
      auth_token: authKey,
      manager_id: loggedInManagerId,
      is_external_api: true
    };

    if (feedId) {
      bodyParams.feed_id = feedId
    }
    if (requestType) {
      bodyParams.request_type = requestType
    }
    //call the api to get the auth key by brand_id and customer_id
    let option:any = this._utilsService.setHeaders();
    option['withCredentials']=false;
    return this._utilsService.postAPICall(tsApiUrl, bodyParams, option);
    // var userProfileResponse = $resource(tsApiUrl, {}, {
    //     post: {
    //         method: 'POST',
    //         //set the withCredentials = false to allow the cross origin access
    //         withCredentials: false
    //     }
    // }).post(bodyParams, function(obj) {
    //     //return the user profile response on callback
    //     cb({ err: false, response: userProfileResponse });
    // }, function(error) {
    //     //return the err on callback
    //     cb({ err: true, response: error });
    // });
  }

  /**
   * Function - getFeedbackRequestTokenFromTS(bodyParams, cb) 
   * Added by - Terkam Patel - 21 June 2017
   * @description Method to get the feedback request token from tokenization server
   *
   * @param      {object}     requestData                 complex object of requests data needs to be sent to generate the token
   * @param      {string}     tsApiUrlToGenerateToken     Url of the tokenization server exposed api to generate the feedback request token
   * @param      {function}   cb                          callback method
   */
  getFeedbackRequestTokenFromTS(bodyParams, tsApiUrlToGenerateToken, cb) {

    return this._utilsService.postAPICall(tsApiUrlToGenerateToken, bodyParams, this._utilsService.setHeaders());
    // //call the api to get the feedback request token from tokenization server
    // var feedbackRequestTokenFromTS = $resource(tsApiUrlToGenerateToken, {}, {
    //     post: {
    //         method: 'POST',
    //         //set the withCredentials = false to allow the cross origin access
    //         withCredentials: false
    //     }
    // }).post(bodyParams, function(obj) {
    //     //return the user profile response on callback
    //     cb({ err: false, response: feedbackRequestTokenFromTS });
    // }, function(error) {
    //     //return the err on callback
    //     cb({ err: true, response: error });
    // });
  }
}
